import {SketchLineMultiRelationConstraint} from './SketchLineMultiRelationConstraint';
import {SketchRelationKind} from "../../index";
import {SketchLineObject} from "../../../../../mesh/sketch";

let count = 0;

/**
 * 线-重合关系约束。
 */
export function isLineCoincidentConstraint(value: object): value is LineCoincidentConstraint {
    return Reflect.get(value, "isLineCoincidentConstraint") === true;
}
export class LineCoincidentConstraint extends SketchLineMultiRelationConstraint<SketchLineObject> {
    readonly isLineCoincidentConstraint: boolean = true;
    /**
     * 关系类型。
     */
    public relationType = SketchRelationKind.Coincident;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    public get baseDisplayName(): string {
        return '重合';
    }

}
